<template>
  <div class="evaluate-acc" v-loading.fullscreen.lock="loading">
    <div class="sec">
      <top :title="'活动详情'"></top>
      <!-- <price-table :type="1"></price-table> -->
      <div class="con spcial" v-html="act_info.assess_info"></div>
    </div>

    <price-form ref="form" :assess_description="config_info.assess_description" :title="'等级账户评估'" :type="1" @submit="submitData" :wechatShow="act_info.display_weixin_assess" :wechat="act_info.service_assess" :qqShow="act_info.display_qq_assess" :sale_extend="act_info.sale_extend*1||0" :qq="act_info.qq_assess"></price-form>

    <div class="sec">
      <top :title="'活动细则'"></top>
      <div class="con" v-html="act_info.assess_rule">
      </div>
    </div>
  </div>
</template>

<script>
import top from '@/components/common/top/top'
import priceTable from '@/components/common/pricetable/priceTable'
import priceForm from '@/components/common/priceform/priceForm'
import { configResource, assessResource } from '@/resource/resource'
import {mapState} from 'vuex'
const ERR_OK = 0

export default {
  name: 'evaluateAcc',
  data () {
    return {
      act_info: {
        service_assess: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['config_info'])
  },
  created () {
    if (!this.config_info.evInfo) {
       this.getRule()
    } else {
      this.act_info = this.config_info.evInfo
    }
  },
  methods: {
    getRule() {
      this.loading = true
      configResource.config({ config: 'assess_rule,assess_info,assess_form_extend,qq_assess,display_qq_assess,display_weixin_assess,service_assess,sale_extend' }).then(response => {
        response = response.body
        this.loading = false
        if (response.errcode === ERR_OK) {
          this.config_info.evInfo = response.data
          this.act_info = response.data
        }
      })
    },
    submitData(data) {
      this.loading = true
      assessResource.assess(data).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$refs.form.clearForm()
            }
          })
        }
      })
    }
  },
  components: {
    top,
    priceTable,
    priceForm
  }
}
</script>

<style lang="stylus" scoped>
.evaluate-acc
  width 1000px
  margin 0 auto
  .sec
    .con
      padding 25px 40px
      color #626262
      font-size 14px
      border 1px solid #dcdcdc
      line-height 22px
</style>



// WEBPACK FOOTER //
// evaluateAcc.vue?4aa1b534